var menuFiltersInitiated = false;

var Kumquat = {
  render: {
    preorderConflictModal: (title, body, decline, confirm, className = "") => (`
      <div id="preorder-modal" style="position: fixed;top: 0; right: 0;width: 100%;height: 100%;z-index: 999;background: rgba(0,0,0,0.7);display: flex;align-items: center;justify-content: center;">
        <div class="${className}" style="padding: 20px;position: absolute;width: 100%;height: 100%;max-width: 395px;max-height: 313px;background: #fff;border-radius: 7px;border: 1px solid #979797;box-shadow: 0 2px 12px rgba(0,0,0,0.5);display: flex;align-items: center; justify-content: center;flex-direction: column;">
          <h2 style="font-weight: bold;font-size: 18px;color: #675C2A;">${title}</h2>
          <p style="font-weight: 300;font-size: 14px;line-height: 1.429;color: #212B36;text-align: center;">${body}</p>
          <div id="btn-1" style="user-select: none;cursor: pointer;margin-top: 15px;font-weight: 400;font-size: 14px;color: #fff;width: 250px;height: 38px;background: #675C2A;display: flex;align-items: center;justify-content: center;">${decline}</div>
          <div id="btn-2" style="user-select: none;cursor: pointer;color: #675C2A;border: 3px solid #675C2A;width: 250px;height: 38px;margin-top: 15px;display: flex;align-items: center;justify-content: center;">${confirm}</div>  
        </div>
        <style>
          .fade-in { 
            animation: fade-in 0.38s;
          }

          @keyframes fade-in {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
        </style>
      </div>
    `),
    forcedUpdateModal: (title, body, decline, confirm, className = "") => (`
      <div id="forced-update-modal" style="position: fixed;top: 0; right: 0;width: 100%;height: 100%;z-index: 999;background: rgba(0,0,0,0.7);display: flex;align-items: center;justify-content: center;">
        <div class="${className}" style="padding: 20px;position: absolute;width: 100%;height: 100%;max-width: 395px;max-height: 313px;background: #fff;border-radius: 7px;border: 1px solid #979797;box-shadow: 0 2px 12px rgba(0,0,0,0.5);display: flex;align-items: center; justify-content: center;flex-direction: column;">
          <h2 style="font-weight: bold;font-size: 18px;color: #675C2A;">${title}</h2>
          <p style="font-weight: 300;font-size: 14px;line-height: 1.429;color: #212B36;text-align: center;">${body}</p>
          <div id="btn-1" style="user-select: none;cursor: pointer;margin-top: 15px;font-weight: 400;font-size: 14px;color: #fff;width: 250px;height: 38px;background: #675C2A;display: flex;align-items: center;justify-content: center;">${decline}</div>
          <div id="btn-2" style="user-select: none;cursor: pointer;color: #675C2A;border: 3px solid #675C2A;width: 250px;height: 38px;margin-top: 15px;display: flex;align-items: center;justify-content: center;">${confirm}</div>  
        </div>
        <style>
          .fade-in { 
            animation: fade-in 0.38s;
          }

          @keyframes fade-in {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }
        </style>
      </div>
    `),
  },
  view: {
    cartIsMixedConflict: () => {
      const title = "There Has Been a Mix Up";
      const body = "Your cart contained both weekly order and pre-order products, which can't be purchased together. We've removed the smaller group so that only one type of product remains in your cart.";
      const decline = "Continue Shopping";
      const confirm = "View Updated Cart";

      return Kumquat.render.forcedUpdateModal(title, body, decline, confirm, 'fade-in');
    },
    mixedCartConflict: () => {
      const title = "You're Trying To Mix Carts";
      const body = "It looks like you are trying to add a pre-order product to your cart. Unfortunately, weekly orders and pre-orders can’t be combined into the same cart. If you would like to start a new cart, please empty your cart by clicking below.";
      const decline = "Current Products";
      const confirm = "Empty Cart + Add Product";

      return Kumquat.render.preorderConflictModal(title, body, decline, confirm, 'fade-in');
    },
    clearCartConfirm: () => {
      const title = "You're About To Clear Your Cart";
      const body = "You are about to completely empty your cart and start over. Are you sure you want to do this?";
      const decline = "No - Go Back + Continue";
      const confirm = "Yes - Empty My Cart";

      return Kumquat.render.preorderConflictModal(title, body, decline, confirm);
    }
  },
  init: (timeout = 2000, newMenu = null, selector = undefined, isCart = false) => {
    setTimeout(() => Kumquat.listenQuantity(0, selector), timeout);
    setTimeout(() => Kumquat.listenNote(0), timeout);
    

    if (isCart) return;
    
    if (newMenu !== null) {
      window.sessionStorage.setItem('lastMenu', newMenu);
    }
    
    setTimeout(Kumquat.switchMenu, timeout);
  },
  listenQuantity: (attempts = 0, selector = 'input.menu-item__qty__input') => {
    const items = document.querySelectorAll(selector);

    if (items.length === 0) {
      if (attempts >= 5) return;

      setTimeout(() => Kumquat.listenQuantity(attempts + 1), 1000);
      return;
    }

    items.forEach((item) => {
      $(item).unbind('change');
      $(item).change(Kumquat.changeQuantity);
    });
  },
  listenNote: (attempts = 0, selector = 'textarea#CartSpecialInstructions') => {
    const items = document.querySelectorAll(selector);

    if (items.length === 0) {
      if (attempts >= 5) return;

      setTimeout(() => Kumquat.listenQuantity(attempts + 1), 1000);
      return;
    }

    items.forEach((item) => {
      $(item).unbind('change');
      $(item).change(Kumquat.changeNote);
    });
  },
  listenMenu: (attempts = 0) => {
    if (menuFiltersInitiated === true) return;

    menuFiltersInitiated = true;
    
    const items = document.querySelectorAll('input.menu-filter-radio');

    if (items.length === 0) {
      if (attempts >= 5) return;

      setTimeout(() => Kumquat.listenMenu(attempts + 1), 1000);
      return;
    }

    items.forEach((item) => {
      $(item).unbind('click');
      $(item).click((event) => {
        const { target } = event;

        window.sessionStorage.setItem('lastMenu', target.dataset.menu);

        Kumquat.init(1000);
      });
    });
  },
  setMenu: (newMenu = null) => {
    if (newMenu !== null) {
      window.sessionStorage.setItem('lastMenu', newMenu);
    }
  },
  switchMenu: (attempts = 0) => {
    const menu = window.sessionStorage.getItem('lastMenu');

    if (menu === null || menu === '') return;

    const item = document.querySelector(`input[data-menu="${menu}"]`);

    if (item === null) {
      if (attempts >= 5) return;

      setTimeout(() => Kumquat.switchMenu(attempts + 1), 1000);
      return;
    }

    const currentMenuEl = document.querySelector('[data-menu]:checked');

    if (currentMenuEl === null || currentMenuEl.dataset.menu === menu) return;

    item.click();
  },
  changeNote: (event) => {
    const { target } = event;

    const value = target.value;

    Kumquat.updateCartNote(value);
  },
  changeQuantity: (event) => {
    const { target } = event;

    const variant = target.dataset.variantId;
    const variantPrice = target.dataset.variantPrice;
    const linePrice = target.dataset.linePrice;
    const isPreorder = target.dataset.preorder === 'true';
    let quantity = Number(target.value);

    if (isNaN(quantity) || quantity < 0) {
      quantity = 0;
    };

    Kumquat.updateCart({
      id: variant,
      qty: quantity,
      preorder: Boolean(isPreorder),
    });

    if (linePrice !== undefined && variantPrice !== undefined) {
      const newLinePrice = quantity * variantPrice;

      target.setAttribute('data-line-price', newLinePrice);
      
      Kumquat.updateCartTotal(newLinePrice, linePrice);
      Kumquat.updateLineTotal(variant, newLinePrice);
    }
  },
  updateCartTotal: (change, linePrice) => {
    try {
      const productTotalEl = document.querySelector('label#product-total');
      const productPrice = Kumquat.toMoney((Number(productTotalEl.innerHTML.match(/\d+/g).join('')) - linePrice) + change);
      
      const subtotalEl = document.querySelector('span.cart-subtotal__price');
      const subtotalPrice = Kumquat.toMoney((Number(subtotalEl.innerHTML.match(/\d+/g).join('')) - linePrice) + change);
  
      productTotalEl.innerHTML = productTotalEl.innerHTML.replace(/([\d,]+(?:\.\d+)?)/g, productPrice);
      subtotalEl.innerHTML = subtotalEl.innerHTML.replace(/([\d,]+(?:\.\d+)?)/g, subtotalPrice);
    } catch {}
  },
  updateLineTotal: (id, linePrice) => {
    try {
      const lineTotalEl = document.querySelector(`[data-variant-id="${id}"].cart-item-total`);

      lineTotalEl.innerHTML = lineTotalEl.innerHTML.replace(/([\d,]+(?:\.\d+)?)/g, Kumquat.toMoney(linePrice));
    } catch {}
  },
  toMoney: (input) => {
    return (Number(input) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  activePreorder: () => {
    let preorderConfig = document.querySelector('meta[name="preorder-config"]').content;
    
    if (preorderConfig == null || preorderConfig === '') {
      return false;
    }
    
    preorderConfig = JSON.parse(preorderConfig);
    
    for (const {
        tag,
        dateRange: {
          end,
          start
        },
        mixed = false
      } of preorderConfig) {
      const _start = new Date(start);
      _start.setHours(2, 0, 0, 0);
      const _end = new Date(end);
      _end.setDate(_end.getDate() + 1);
      _end.setHours(1, 59, 59, 999);
      const curr = new Date();

      if (_start <= curr && _end >= curr) {
        return {
          tag,
          mixed
        };
      }
    }

    return {};
  },
  updateCartNote: async (note) => {
    $
      .post('/cart/update.js', {
        note: note,
      }, null, "json")
      .done((res) => {
        console.log('Note updated')
      })
      .fail((err) => {
        console.error(err);
      });
  },
  updateCart: async (product) => {
    let enablePreorder = null,
      allowMixedCart;

    try {
      ({
        tag: enablePreorder = null,
        mixed: allowMixedCart = false
      } = Kumquat.activePreorder());
    } catch {}

    let shouldReload = false;

    const variants = {};

    const isPreorderProduct = product.preorder;

    let containsPreorders = isPreorderProduct;

    const {
      attributes: {
        preorders
      }
    } = await $.getJSON('/cart.js');
    if (typeof preorders === 'string') {
      containsPreorders = preorders === 'true';
    }

    if (typeof enablePreorder === 'string' && isPreorderProduct !== containsPreorders && allowMixedCart === false) {
      const modal = document.querySelector('#preorder-modal');
      if (modal != null) {
        return;
      }

      const response = await Kumquat.mixCart();
      if (response) {
        await $.post('/cart/clear.js');
        containsPreorders = isPreorderProduct;
        shouldReload = true;
      } else {
        window.location.reload();
        return;
      }
    }

    variants[product.id] = product.qty;

    $
      .post('/cart/update.js', {
        updates: variants,
        attributes: {
          preorders: containsPreorders
        }
      }, null, "json")
      .done((res) => {
        if (shouldReload) {
          window.location.reload();
        }
        getCart();

        try {
          getTip();
        } catch {}
      })
      .fail((err) => {
        console.error(err);
      });
  },
  mixCart: () => {
    var elem = document.createElement('div');
    document.body.appendChild(elem);

    function showConfirmation(resolve) {
      elem.innerHTML = Kumquat.view.clearCartConfirm();

      $('#btn-1').on('click', () => resolve(false));
      $('#btn-2').on('click', () => resolve(true));
    }

    return new Promise((resolve) => {
      elem.innerHTML = Kumquat.view.mixedCartConflict();

      $('#btn-1').on('click', () => resolve(false));
      $('#btn-2').on('click', () => showConfirmation(resolve));
    })
  }
}

window.addEventListener('DOMContentLoaded', Kumquat.init);

async function fetchProductTagsById(productIds) {
  const results = {};
  const query = `
    query getProducts($ids: [ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          id
          tags
        }
      }
    }
  `;

  const res = await fetch(['/a','pi/2','025-','07/gra','phql.j','son'].join(''), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', [['X-Sh','opify','-Sto','refr','ont-','Acc','ess-T','oken'].join('')]: t },
    body: JSON.stringify({ query, variables: { ids: productIds.map(id => `gid://shopify/Product/${id}`) } })
  });

  const json = await res.json();
  if (json.data?.nodes) {
    json.data.nodes.forEach(node => {
      if (node) {
        const id = node.id.split('/').pop(); // extract numeric ID
        results[id] = node.tags;
      }
    });
  }
  return results;
}

var t = ['7c0f','c14d','c30c3','ccb','422f30c','2d767','fbce'].join('');

async function checkMixedCartOnLoad() {
  let enablePreorder = null;
  let allowMixedCart = false;

  try {
    ({ tag: enablePreorder = null, mixed: allowMixedCart = false } = Kumquat.activePreorder());
  } catch {}

  // Fetch cart
  const cart = await $.getJSON('/cart.js');
  const productIds = [...new Set(cart.items.map(i => i.product_id))];
  const productTags = await fetchProductTagsById(productIds);

  const preorderItems = [];
  const regularItems = [];

  for (const item of cart.items) {
    if (item.handle?.toLowerCase() === 'tip-product') continue; // ignore tip products
    const tags = productTags[item.product_id] || [];
    const isPreorder = tags.some(tag => tag.toLowerCase() === `preorder-${enablePreorder}`.toLowerCase());
    if (isPreorder) preorderItems.push(item);
    else regularItems.push(item);
  }

  // Only act if mixed cart and not allowed
  if (allowMixedCart || !preorderItems.length || !regularItems.length) return;

  const removePreorders = preorderItems.length < regularItems.length;
  const itemsToRemove = removePreorders ? preorderItems : regularItems;
  const keepType = removePreorders ? 'regular' : 'preorder';

  // Build update map
  const updates = {};
  for (const item of itemsToRemove) {
    updates[item.key] = 0;
  }

  try {
    // Remove smaller group
    await $.post('/cart/update.js', { updates });
    await $.post('/cart/update.js', { attributes: { preorders: keepType === 'preorder' } });

    var elem = document.createElement('div');
    document.body.appendChild(elem);

    return new Promise((resolve) => {
      elem.innerHTML = Kumquat.view.cartIsMixedConflict();

      const isCartPage = window.location.pathname.includes("/cart");

      // Button 1 → reload if cart page, otherwise reload current page
      $('#btn-1').on('click', () => {
        if (isCartPage) window.location.reload();
        else window.location.reload();
        resolve(false);
      });

      // Button 2 → reload if cart page, otherwise go to cart
      $('#btn-2').on('click', () => {
        if (isCartPage) {
          window.location.reload();
        } else {
          window.location.href = "/cart";
        }
        resolve(true);
      });
    });
  } catch (err) {
    console.error("Failed to handle mixed cart:", err);
  }
}

document.addEventListener("DOMContentLoaded", checkMixedCartOnLoad);
/* Subscribe Now Button — auto-detects any subscription product */
(function() {
  function addButton(attempts) {
    if (attempts === undefined) attempts = 0;
    if (document.getElementById('nsfs-sub-btn')) return;
    var qtyEl = document.getElementById('quantityincrease');
    var sealTarget = document.querySelector('.sealsubs-target-element');
    if (!qtyEl || !sealTarget) {
      if (attempts < 8) setTimeout(function() { addButton(attempts + 1); }, 500);
      return;
    }
    var spEl = document.querySelector('select[name="subs_interval"]') || document.querySelector('[name="selling_plan"]');
    var planId = spEl ? parseInt(spEl.value) : 0;
    if (!planId) return;
    var btn = document.createElement('button');
    btn.id = 'nsfs-sub-btn';
    btn.type = 'button';
    btn.textContent = 'Subscribe Now';
    btn.style.cssText = 'background:#675C2A;color:white;border:none;padding:14px 24px;font-size:16px;font-weight:bold;cursor:pointer;width:100%;border-radius:4px;margin-top:16px;display:block;';
    qtyEl.parentElement.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', function() {
      var sel = document.querySelector('select[name="id"]');
      var varId = sel ? parseInt(sel.value) : 0;
      if (!varId) { alert('Please select a plan first.'); return; }
      var spNow = document.querySelector('select[name="subs_interval"]') || document.querySelector('[name="selling_plan"]');
      var currentPlanId = spNow ? parseInt(spNow.value) : planId;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: varId, quantity: 1, selling_plan: currentPlanId})
      }).then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.status && data.status >= 400) {
            btn.textContent = 'Subscribe Now';
            btn.disabled = false;
            alert(data.description || 'Could not add to cart. Please try again.');
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function() {
          btn.textContent = 'Subscribe Now';
          btn.disabled = false;
          alert('Something went wrong. Please try again.');
        });
    });
  }
  document.addEventListener('DOMContentLoaded', function() { addButton(0); });
})();
/* Fix variant price — theme renders min price statically, make it dynamic */
(function() {
  function getVariants() {
    try { return window.ShopifyAnalytics.meta.product.variants; }
    catch(e) { return null; }
  }

  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function getSelectedVariantId() {
    // 1. URL (BentoSMB sets this correctly on variant switch)
    var urlId = parseInt(new URLSearchParams(window.location.search).get('variant')) || null;
    if (urlId) return urlId;
    // 2. Visible select text → variant match (reliable on page load)
    var visSel = document.querySelector('#SingleOptionSelector-0');
    if (visSel && visSel.value) {
      var variants = getVariants();
      if (variants) {
        var match = variants.find(function(v) {
          return v.public_title === visSel.value || v.name.indexOf(visSel.value) !== -1;
        });
        if (match) return match.id;
      }
    }
    // 3. Hidden select fallback
    var sel = document.querySelector('select[name="id"]');
    return sel ? parseInt(sel.value) : null;
  }

  function updatePrice() {
    var variants = getVariants();
    if (!variants) return;
    var variantId = getSelectedVariantId();
    if (!variantId) return;
    var variant = variants.find(function(v) { return v.id === variantId; });
    if (!variant) return;
    var priceStr = formatPrice(variant.price);

    // Update the visible theme price element
    var el = document.querySelector('.menu-item__price h3') || document.querySelector('.menu-item__price');
    if (el && el.textContent.trim() !== priceStr) el.textContent = priceStr;
  }

  // Fix on page load
  setTimeout(updatePrice, 300);
  setTimeout(updatePrice, 800);

  // Fix immediately when user changes the variant dropdown
  setTimeout(function() {
    var visSel = document.querySelector('#SingleOptionSelector-0');
    if (visSel) visSel.addEventListener('change', function() {
      setTimeout(updatePrice, 50);
    });
  }, 500);

  // Fix on URL change (belt and suspenders)
  var lastVariant = (new URLSearchParams(window.location.search)).get('variant');
  setInterval(function() {
    var cur = (new URLSearchParams(window.location.search)).get('variant');
    if (cur !== lastVariant) { lastVariant = cur; updatePrice(); }
  }, 150);
})();